import { ErrorOutline } from '@mui/icons-material';

import { Container, Title } from './styles';

interface InfoCardProps {
  title: string;
  type?: 'success' | 'error' | 'info' | 'warning';
}

const SX = { width: '80px', height: '80px' };

export const InfoCard = ({ title, type }: InfoCardProps) => {
  return (
    <Container>
      {type && <ErrorOutline color={type} sx={SX} />}
      <Title>{title}</Title>
    </Container>
  );
};
